import React from 'react';
import { Wand2, Users, Layout } from 'lucide-react';

export function WelcomeStep() {
  return (
    <div className="text-center">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">
        Welcome to DrillFlo
      </h1>
      {/* <img src="/assets/dot/dot.png" alt="Dot from DrillFlo" className="w-40 h-40 mx-auto mb-6" /> */}
      {/* <p className="text-gray-600 mb-12 max-w-lg mx-auto">
        Create your drill designs with ease. Our online tools help you bring your ideas to life, whether you're designing for marching bands, color guards, or drum corps.
      </p> */}

      <div className="grid grid-cols-3 gap-8 max-w-2xl mx-auto">
        <div className="text-center">
          <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mx-auto mb-4">
            <Wand2 className="w-6 h-6 text-blue-500" />
          </div>
          <h3 className="font-medium text-gray-900 mb-2">Intuitive Design</h3>
          <p className="text-sm text-gray-500">Create drill designs with our easy-to-use tools</p>
        </div>

        <div className="text-center">
          <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mx-auto mb-4">
            <Users className="w-6 h-6 text-blue-500" />
          </div>
          <h3 className="font-medium text-gray-900 mb-2">Performer Management</h3>
          <p className="text-sm text-gray-500">Organize your ensemble to make design easier</p>
        </div>

        <div className="text-center">
          <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mx-auto mb-4">
            <Layout className="w-6 h-6 text-blue-500" />
          </div>
          <h3 className="font-medium text-gray-900 mb-2">Smart Templates</h3>
          <p className="text-sm text-gray-500">Start quickly with pre-built ensembles to get you started</p>
        </div>
      </div>
    </div>
  );
}